/** @format */

import request from 'src/utils/request'

// 触发器列表
export const getTriggerList = async (params?) => {
  const result = await request('/oos/?Action=ListTrigger&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Data
}

// 触发器详情
export const getTriggerDetail = async (params?) => {
  const result = await request('/oos/?Action=GetTrigger&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data?.Data || {}
}

// 保存触发器
export const saveTrigger = async (params?) => {
  const result = await request('/oos/?Action=SaveTrigger&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Code === 'success' ? result?.data?.Data : false
}

// 删除触发器
export const deleteTrigger = async (params?) => {
  const result = await request('/oos/?Action=DeleteTrigger&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 触发器执行记录
export const getTriggerRecordList = async (params?) => {
  const result = await request('/oos/?Action=ListTriggerRecord&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Data
}

// 执行记录详情
export const getTriggerRecordDetail = async (params?) => {
  const result = await request('/oos/?Action=GetTriggerRecord&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data?.Data || {}
}

// 触发器的操作日志
export const getTriggerLogList = async (params?) => {
  const result = await request('/oos/?Action=ListTriggerLog&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Data || {}
}

// 开启/禁用触发器
export const enableTrigger = async (params?) => {
  const result = await request('/oos/?Action=EnableTrigger&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 发起审批
export const approveTrigger = async (params?) => {
  const result = await request('/oos/?Action=CreateAudit&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Code === 'success' ? true : false
}

// 审批
export const applyAudit = async (params?) => {
  const result = await request('/oos/?Action=ApplyAudit&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 查询历史事件
export const getHistoryEvent = async (params?) => {
  const result = await request(
    '/monitor/?Action=DescribeSystemEventAttributes&Version=2025-11-25',
    {
      data: {
        ...params,
        Format: 'event'
      },
      method: 'POST'
    }
  )
  return result?.data || {}
}
